import { render, staticRenderFns } from "./BrandSlider.vue?vue&type=template&id=13a2e925&scoped=true"
import script from "./BrandSlider.vue?vue&type=script&lang=js"
export * from "./BrandSlider.vue?vue&type=script&lang=js"
import style0 from "./BrandSlider.vue?vue&type=style&index=0&id=13a2e925&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13a2e925",
  null
  
)

export default component.exports